/* eslint-disable  @typescript-eslint/no-explicit-any */
/* jscpd:ignore-start */
import axios from '@/plugins/axios'
import { Module } from 'vuex'

export interface Change {
    username: string
    token: string
}

const changeModule: Module<any, any> = {
    state: {
        changes: [],
        totalRows: 0,
    },

    actions: {
        // Add auth headers
        async UpdateChange({ dispatch }, change: Change) {
            await axios.post('/changes', change)
            return await dispatch('GetChanges')
        },

        async DeleteChange({ dispatch }, change: Change) {
            await axios.delete('/changes', change)
            return await dispatch('GetChanges')
        },

        async GetChanges({ commit }, { page, num, search }) {
            // let response = await axios.get("/changes");
            // Do some caching?

            const filterServerSide = false

            // cSpell:disable Fake up some data
            const person = [
                {
                    id: 98,
                    name: '',
                    firstName: 'Leslie',
                    lastName: 'Burrow',
                    profile: '/images/profile-img/img-01.jpg',
                    username: 'l.burrow@socialhp.com',
                },
                {
                    id: 99,
                    name: '',
                    firstName: 'Courtney',
                    lastName: 'Henry',
                    profile: '/images/profile-img/img-02.jpg',
                    username: 'c.henry@socialhp.com',
                },
                {
                    id: 100,
                    name: '',
                    firstName: 'Sophie',
                    lastName: 'Lee',
                    profile: '/images/profile-img/img-03.jpg',
                    username: 's.lee@socialhp.com',
                },
                {
                    id: 101,
                    name: '',
                    firstName: 'Karam',
                    lastName: 'Ghuman',
                    profile: '/images/profile-img/img-04.jpg',
                    username: 'k.ghuman@socialhp.com',
                },
                {
                    id: 102,
                    name: '',
                    firstName: 'Manjit',
                    lastName: 'Kaur',
                    profile: '/images/profile-img/img-05.jpg',
                    username: 'm.kaur@socialhp.com',
                },
                {
                    id: 103,
                    name: '',
                    firstName: 'Rechie',
                    lastName: 'Rechie',
                    profile: '/images/profile-img/img-06.jpg',
                    username: 'r.rechie@socialhp.com',
                },
                {
                    id: 104,
                    name: '',
                    firstName: 'Mary',
                    lastName: 'Sinclair',
                    profile: '/images/profile-img/img-07.jpg',
                    username: 'm.sinclair@socialhp.com',
                },
                {
                    id: 105,
                    name: '',
                    firstName: 'Theresa',
                    lastName: 'Hamilton',
                    profile: '/images/profile-img/img-08.jpg',
                    username: 't.hamilton@socialhp.com',
                },
                {
                    id: 106,
                    name: '',
                    firstName: 'Mamert',
                    lastName: 'Santelices',
                    profile: '/images/profile-img/img-09.jpg',
                    username: 'm.santelices@socialhp.com',
                },
                {
                    id: 107,
                    name: '',
                    firstName: 'John Paul',
                    lastName: 'Quijano',
                    profile: '/images/profile-img/img-10.jpg',
                    username: 'j.quijano@socialhp.com',
                },
                {
                    id: 108,
                    name: '',
                    firstName: 'Shane',
                    lastName: 'Iseminger',
                    profile: '/images/profile-img/img-11.jpg',
                    username: 's.iseminger@socialhp.com',
                },
                {
                    id: 109,
                    name: '',
                    firstName: 'Alen',
                    lastName: 'Bubich',
                    profile: '/images/profile-img/img-12.jpg',
                    username: 'a.bubich@socialhp.com',
                },
                {
                    id: 110,
                    name: '',
                    firstName: 'Thomas',
                    lastName: 'Conors',
                    profile: '/images/profile-img/img-13.jpg',
                    username: 't.conors@socialhp.com',
                },
                {
                    id: 111,
                    name: '',
                    firstName: 'Nguyen',
                    lastName: 'Anh',
                    profile: '/images/profile-img/img-14.jpg',
                    username: 'n.anh@socialhp.com',
                },
                {
                    id: 112,
                    name: '',
                    firstName: 'Stanley',
                    lastName: 'Meade',
                    profile: '/images/profile-img/img-15.jpg',
                    username: 's.meade@socialhp.com',
                },
                {
                    id: 113,
                    name: '',
                    firstName: 'Laura',
                    lastName: 'Babcock',
                    profile: '/images/profile-img/img-16.jpg',
                    username: 'l.babcock@socialhp.com',
                },
                {
                    id: 114,
                    name: '',
                    firstName: 'Vasuki',
                    lastName: 'Uthayakumar',
                    profile: '/images/profile-img/img-17.jpg',
                    username: 'v.uthayakumar@socialhp.com',
                },
            ]
            const changeType = [
                'approved',
                'submitted for approval',
                'deleted',
                'edit',
            ]
            // cSpell:enable

            const data = []
            const totalRows = 20
            for (let i = 0; i < totalRows; i++) {
                const updateDate = new Date()
                updateDate.setMinutes(
                    updateDate.getMinutes() - Math.floor(Math.random() * 3000),
                )
                data.push({
                    id: Math.floor(Math.random() * 100000),
                    changeType:
                        changeType[
                            Math.floor(Math.random() * changeType.length)
                        ],
                    parameter: 'Domain URL',
                    previousValue: 'www.anotherwebsite.com',
                    ipAddress: '176.994.234.222',
                    updatedBy:
                        person[Math.floor(Math.random() * person.length)],
                    updateDate: updateDate,
                })
            }

            const response = {
                data: data,
                totalRows: totalRows,
            }

            const changes = response.data

            let filteredChanges = changes

            if (search && search.length && !filterServerSide) {
                const searchLower = search.toLowerCase()
                filteredChanges = changes.filter((change) => {
                    return (
                        change.name.toLowerCase().indexOf(searchLower) > -1 ||
                        change.createdBy.firstName
                            .toLowerCase()
                            .indexOf(searchLower) > -1 ||
                        change.createdBy.lastName
                            .toLowerCase()
                            .indexOf(searchLower) > -1 ||
                        change.createdBy.username
                            .toLowerCase()
                            .indexOf(searchLower) > -1
                    )
                })
            }

            const indexFrom = (page - 1) * num
            let indexTo = num * page
            indexTo =
                indexTo < filteredChanges.length
                    ? indexTo
                    : filteredChanges.length
            const finalChanges = filterServerSide
                ? filteredChanges
                : filteredChanges.slice(indexFrom, indexTo)

            commit('setChanges', finalChanges)
            commit('setTotalRows', response.totalRows)

            return finalChanges
        },
    },

    mutations: {
        setChanges(state: any, changes) {
            state.changes = changes
        },
        setTotalRows(state: any, rows: number) {
            state.totalRows = rows
        },
    },
}

export default changeModule
/* jscpd:ignore-end */
